<template>
  <div :class="['faded-image']">
    <div class="fade-top"></div>
    <div class="fade-right"></div>
    <div class="fade-bottom"></div>
    <div class="fade-left"></div>
    <img :src="`/figures/${this.name}`" />
  </div>
</template>

<script>
export default {
  name: "FadedImage",
  props: ["name"],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {},
};
</script>

<style scoped>

.faded-image {
  position: relative;
  width: 100%;
}

img {
  width: 100%;
  height: auto;
  display: flex;
}

.fade-top {
  background: linear-gradient(180deg, var(--color-background) 0%, rgba(0, 0, 0, 0) 100%);
  width: 100%;
  height: 4px;
  position: absolute;
}

.fade-right {
  background: linear-gradient(-90deg, var(--color-background) 0%, rgba(0, 0, 0, 0) 100%);
  width: 4px;
  height: 100%;
  right: 0;
  position: absolute;
}

.fade-bottom {
  background: linear-gradient(0deg, var(--color-background) 0%, rgba(0, 0, 0, 0) 100%);
  width: 100%;
  height: 4px;
  bottom: 0;
  position: absolute;
}

.fade-left {
  background: linear-gradient(90deg, var(--color-background) 0%, rgba(0, 0, 0, 0) 100%);
  height: 100%;
  width: 4px;
  left: 0;
  position: absolute;
}
</style>
